




















































































import { Component } from 'vue-property-decorator';
import { DealAttachmentJson, CustomerContactInfo } from '@/models/filebunker/deal';
import { AttachmentViewModel } from '@/models/fixedops/attachment';
import { Utils } from '@/helper/utils';
import { FileViewModel, NewFaxViewModel } from '@/models/telephony/message';
import { FaxLine } from '@/models/admin/store';
import { VHeaders, VAction } from '@/models/pagedlistmodel';
import {
  ConversationTypes
} from '@/enums/enums';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {
  attachmentTypeService,
  weOweService,
  messageService,
  storeService,
  customerService,
  attachmentService,
} from '@/shared';
import { FileSize } from '@/helper/enum';
import { IFileUploaderOption } from '@/models/fileUploader';

@Component({
  props: ['methodName', 'progress'],
  computed: {
    methodtoCall: {
      get() {
        return this.$props.methodName;
      },
    },
  },
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    EmailAttachment: () => import('@/components/common/email.attachment.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    SnackBarLoader: () => import('@/components/common/loader.vue'),
    FileUpload: () => import('@/components/common//app.fileupload.v2.vue'),
    // FileUpload: VueUploadComponent,
  },
})
export default class WeOweAttachmentsPage extends Base {
  public window: any = window;
  public weOweAttachmentLoader: boolean = false;
  public loading: boolean = false;
  public attachments: DealAttachmentJson[] = [];
  public customerInfo: CustomerContactInfo = {};
  public emailUrl: string = '';
  public customerKey: string = '';
  public weOweNumber: string = '';
  public showEmailDialog: boolean = false;
  public isPublic: boolean = false;
  public attachmentTypes: any = [];
  public selectedAttachmentType: number = null;
  public attachmentId: string = '';
  public requestProgress: boolean = false;
  public customerLoading: boolean = false;

  // Dialog
  public editDialog: IDialogOption = {
    width: 500,
    title: this.$parent.$t('weOweAttachment.editDialog.title') as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-edit',
      text: this.$parent.$t('weOweAttachment.editDialog.lblUpdate') as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };
  public commentDialog: IDialogOption = {
    width: 500,
    title: ' ',
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t('weOweAttachment.commentDialog.lblSave') as string,
    },
    onAction: (): void => {
      this.updateAttachmentType();
    },
  };
  public showFaxDialog: IDialogOption = {
    width: 500,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-paper-plane',
      text: this.$parent.$t('weOweAttachment.faxDialog.lblSend') as string,
    },
    onAction: (): void => {
      this.sendFax();
    },
  };

  public commentText: string = '';
  public files: any = [];
  public selectedFiles: any = [];
  public dragclass: string = '';
  public dragging: boolean = false;
  public attachmentFiles: FileViewModel[] = [];
  public availableFaxNumbers: FaxLine[] = [];

  public fileUploderRef: string = "weOweAttachment";
  public fileDialog: IFileUploaderOption = {
    ref: this.fileUploderRef,
    inputFiles: this.files,
    multiple: true,
    drop: true,
    // extensions: ['.csv', '.xlsx'] // no need to mention extension just allow everything
  };
  public syncAttachmentFiles(inputFilesToSync: any[], outputFilesToSync: FileViewModel[]) {
    this.files = inputFilesToSync;
    this.attachmentFiles = outputFilesToSync;
  }
  

  public faxToSend: NewFaxViewModel = new NewFaxViewModel(
    ConversationTypes[ConversationTypes.Fax]
  );

  public actions: VAction[] = [
    {
      type: 'button',
      icon: 'fas fa-eye',
      title: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.gridAction.viewAttachments'
      ) as string,
      loading: false,
      action: (model: AttachmentViewModel, action: VAction) => {
        this.openAttachment(model.attachmentId, action);
      },
    },
    {
      type: 'button',
      icon: 'fas fa-paper-plane',
      title: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.gridAction.sendAttachment'
      ) as string,
      action: (model: AttachmentViewModel) => {
        this.generateEmail(model);
      },
    },
    {
      type: 'button',
      icon: 'fa fa-sticky-note',
      title: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.gridAction.comment'
      ) as string,
      action: (model: AttachmentViewModel) => {
        this.showCommentDialog(model.attachmentId);
      },
    },
  ];
  public headers: VHeaders[] = [
    {
      text: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.attachmentType'
      ) as string,
      align: 'left',
      value: 'attachmentTypeName',
    },
    {
      text: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.uploadedAt'
      ) as string,
      align: 'left',
      value: 'createdAt',
      fieldType: 'date',
    },
    {
      text: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.comments'
      ) as string,
      align: 'left',
      value: 'comment',
    },
    {
      text: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.isPublic'
      ) as string,
      align: 'left',
      value: 'isPublic',
      fieldType: 'switch',
      onChange: (item: any): void => {
        if (item.isPublic) {
          this.togglePublic(item.attachmentId, true);
        } else {
          this.togglePublic(item.attachmentId, false);
        }
      },
      title: (item: any): string => {
        if (item) {
          return item.isPublic ? 'Public' : 'Not Public';
        }
      },
      disabled: (item: any): boolean => {
        return (
          item.attachmentTypeName === 'WeOwe Document' ||
          item.attachmentTypeName === 'File Bunker'
        );
      },
    },
    {
      text: this.$parent.$t(
        'weOweAttachment.weOweAttachmentGrid.action'
      ) as string,
      align: 'center',
      isNotDataProp: true,
      sortable: false,
    },
  ];

  public callMethod(methodName): void {
    if (methodName === 'backToList') {
      this.backToList();
    }
    this.resetMethodName(methodName);
  }
  public resetMethodName(methodName): void {
    if (methodName !== '') {
      this.$emit('resetMethodName', methodName);
    }
  }
  public updateToolBar(): void {
    const buttons: any = [];
    buttons.push({
      id: 0,
      type: 'button',
      title: this.$parent.$t('weOweAttachment.btnBackToList') as string,
      disabled: false,
      visible: true,
      class: 'btn',
      label: this.$parent.$t('weOweAttachment.btnBackToList') as string,
      click: 'backToList',
      icon: 'fas fa-arrow-left',
      requestProgress: true,
    });
    this.$emit('updateToolBar', buttons);
  }

  public mounted(): void {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'weowe');

    // toolbar
    this.updateToolBar();
    this.$watch('methodtoCall', (newVal, oldVal) => {
      if (newVal) {
        this.callMethod(newVal);
      }
    });

    this.weOweNumber = this.$route.params.weOweNumber;
    this.customerKey = this.$route.params.customerkey;
    this.getCustomerInfo(this.customerKey);
    this.getAttachments(this.weOweNumber);
    this.getAttachmentTypes();
    this.getAvailableFaxNumbers();
  }

  public async getAttachments(weOweNumber: string): Promise<void> {
    try {
      this.loading = true;
      const attachments = await weOweService.getAttachments(weOweNumber);
      this.attachments = attachments.results;
    } finally {
      this.loading = false;
    }
  }

  public async getCustomerInfo(customerKey): Promise<void> {
    try {
      this.customerLoading = true;
      const customerInfo = await customerService.getCustomerInfoAsync(
        customerKey
      );
      this.customerInfo = customerInfo;
      this.customerInfo.to = [];
      this.customerInfo.to.push(
        this.customerInfo.email1 || this.customerInfo.email2
      );
      this.customerInfo.cc = [];
    } finally {
      this.customerLoading = false;
    }
  }

  public generateEmail(model: AttachmentViewModel): void {
    this.emailUrl = `${Utils.API_BASE_URL}/weowe/attachment/${model.attachmentId}/sendmail`;
    this.showEmailDialog = true;
  }

  public async getAttachmentTypes(): Promise<void> {
    const attachmentTypes = await attachmentTypeService.getAttachmentTypes();
    this.attachmentTypes = attachmentTypes.results;
  }

  public async getAvailableFaxNumbers(): Promise<void> {
    const faxLines = await storeService.getFaxLines();
    this.availableFaxNumbers = faxLines.results;
  }

  public backToList() {
    if (history.state && history.length > 1) {
      this.$router.back();
    } else {
      this.$router.push({ name: 'app.weowe' });
    }
  }

  public async openAttachment(
    attachmentId: string,
    action: VAction
  ): Promise<void> {
    try {
      action.loading = true;
      this.weOweAttachmentLoader = true;
      await attachmentService.viewAttachmentAsync(attachmentId);
    } finally {
      action.loading = false;
      this.weOweAttachmentLoader = false;
    }
  }

  public hideDialog(): void {
    this.showEmailDialog = false;
  }

  public showEditDialog(attachmentId: string): void {
    this.editDialog.model = true;
    this.attachmentId = attachmentId;
    this.commentText = '';
  }

  public showCommentDialog(attachmentId: string): void {
    this.selectedAttachmentType = null;
    this.commentText = '';
    this.commentDialog.model = true;
    this.attachmentId = attachmentId;
    const data = this.attachments.filter((item) => {
      if (item.attachmentId === attachmentId) {
        return item;
      }
    });
    if (data.length > 0) {
      this.commentText = data[0].comment;
    }

    if (this.commentText !== '' && this.commentText != null) {
      this.commentDialog.title = this.$parent.$t(
        'weOweAttachment.commentDialog.editTitle'
      ) as string;
    } else {
      this.commentDialog.title = this.$parent.$t(
        'weOweAttachment.commentDialog.addTitle'
      ) as string;
    }
  }

  public async updateAttachmentType(): Promise<void> {
    try {
      this.commentDialog.loading = true;
      this.editDialog.loading = true;
      await weOweService.updateAttachment(
        this.attachmentId,
        this.selectedAttachmentType,
        this.commentText
      );
      this.getAttachments(this.weOweNumber);
    } finally {
      this.editDialog.loading = true;
      this.commentDialog.loading = false;
      this.editDialog.model = false;
      this.commentDialog.model = false;
    }
  }

  public async UploadAttachment() {
    if (this.attachmentFiles.length > 0) {
      try {
        this.requestProgress = true;
            await weOweService.uploadFile(
              this.weOweNumber,
              this.isPublic,
              this.attachmentFiles
            );
            this.showAlert(
              true,
              this.$t('weOweAttachment.alertAttachmentUploaded')
            );
            this.attachmentFiles = [];
            this.selectedFiles = '';
            this.files = [];
            this.getAttachments(this.weOweNumber);
      } finally {
        this.requestProgress = false;
        this.attachmentFiles = [];
        this.files = [];
        this.$root.$emit('resetFileList', this.fileUploderRef);
      }
    }else {
      this.showAlert(false, this.$t('vehicleReviveAttachment.alertSelectFileForUpload'));
    }
  }

  public async sendFax(): Promise<void> {
    if (!this.faxToSend.from || this.faxToSend.from.trim() === '') {
      this.showAlert(false, this.$t('weOweAttachment.alertFromFaxNumber'));
      return;
    }

    if (!this.faxToSend.to || this.faxToSend.to.trim() === '') {
      this.showAlert(false, this.$t('weOweAttachment.alertToFaxNumber'));
      return;
    }
    try {
      this.showFaxDialog.loading = true;
      await messageService.sendFax(this.faxToSend);
      this.showAlert(true, this.$t('weOweAttachment.alertFaxSubmitted'));
    } finally {
      this.showFaxDialog.loading = false;
      this.showFaxDialog.model = false;
    }
  }

  public async togglePublic(id: string, status: boolean): Promise<void> {
    await attachmentService.toggleIsPublicAsync(id, status);
    this.showAlert(true, this.$t('weOweAttachment.alertAttachmentUpdated'));
  }

  public fileUploadLoader(val: boolean) {
    this.requestProgress = val;
  }

}
